import { render, staticRenderFns } from "./ActiveManageView.vue?vue&type=template&id=0c0c4550&scoped=true&"
import script from "./ActiveManageView.vue?vue&type=script&lang=js&"
export * from "./ActiveManageView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0c4550",
  null
  
)

export default component.exports